const ITEMS = ['New Drop Live', 'Cut for Daylight', 'Small Runs Only', 'Canada & US Delivery', 'Wear It Your Way'];

export const FashionTicker = () => (
  <section className="overflow-hidden border-y border-[#B9C4B6] bg-[#C7D1C3] py-4 text-[#1E1E1E]" data-testid="fashion-ticker">
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((group) => (
        <div key={group} className="flex items-center">
          {[...ITEMS, ...ITEMS].map((item, index) => (
            <span key={`${group}-${item}-${index}`} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-syne text-sm font-extrabold uppercase sm:text-base">{item}</span>
              <span className="h-2 w-2 bg-[#7A8B99]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);